/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";

export interface Typ {
    bezeichnung: string;
    felder: Array<Feld>;
}

export interface Feld {
    bezeichnung: string;
    istListe: boolean;
    istObjekt: boolean;
    hatGraphQLTypName: boolean;
    graphQLTypName: string;
    feldRegeln: Array<FeldRegel>;
    vergleichsRegeln: Array<VergleichsRegel>;
}

export interface FeldRegel {
    bezeichnung: string;
}

export interface VergleichsRegel {
    anderesFeld: string;
    bezeichnung: string;
}

export default class PromiseLadeTypen extends PromiseQuery<Typ[], undefined> {
    public static readonly queryName = "DomainDrivenDesign_LadeTypen";

    private static readonly query = gql`
        query ${PromiseLadeTypen.queryName} {
            ${PromiseLadeTypen.queryName} {
                bezeichnung
                felder {
                    bezeichnung
                    istListe
                    istObjekt
                    graphQLTypName
                    hatGraphQLTypName
                    feldRegeln {
                        bezeichnung
                    }
                    vergleichsRegeln {
                        anderesFeld
                        bezeichnung
                    }
                }
            }
        }
    `;

    constructor() {
        super(PromiseLadeTypen.query);
    }

    public get name(): string {
        return PromiseLadeTypen.queryName;
    }
}
